import React, { useState, useEffect } from "react";
import "./AddProjectModal.css";
import { useLanguage } from "../../../../../LanguageProvider";
import { IoCloseOutline } from "react-icons/io5";
import { TbStack2 } from "react-icons/tb";
import { IoDocumentTextOutline } from "react-icons/io5";
import AddModalInputField from "../../../../AddModalInputField/AddModalInputField";
import { useToaster } from "../../../../../ToasterProvider";

export default function AddProjectModal({
  isOpen,
  onClose,
  onCreate,
  isEdit = false,
  title = "",
  description = "",
  isWorkspace = false
}) {
  const { toastWarning } = useToaster();
  const { getTranslation } = useLanguage();
  const [projectTitle, setProjectTitle] = useState("");
  const [projectDescription, setProjectDescription] = useState("");

  useEffect(() => {
    if (isOpen) {
      if (isEdit) {
        setProjectTitle(title);
        setProjectDescription(description);
      } else {
        setProjectTitle("");
        setProjectDescription("");
      }
    }
  }, [isEdit, isOpen, title, description]);

  if (!isOpen) return null;

  const handleCreate = () => {
    if (projectTitle.trim() === "") {
      toastWarning(isWorkspace ? getTranslation("workspaceNameCantBeEmpty") : getTranslation("projectNameCantBeEmpty"));
      return;
    }
    onCreate(projectTitle, projectDescription);
    onClose();
    setProjectTitle("");
    setProjectDescription("");
  };

  const handleClose = () => {
    onClose();
    setProjectTitle("");
    setProjectDescription("");
  }

  return (
    <div className="add-project-modal-overlay">
      <div className="add-project-modal-container">
        <IoCloseOutline
          className="add-project-modal-button close"
          onClick={handleClose}
        />

        <p className="add-project-modal-title">
          {isEdit
            ? getTranslation("editProject")
            : (isWorkspace ? getTranslation("createNewWorkspace") : getTranslation("createNewProject"))}
        </p>

        <AddModalInputField
          icon={<TbStack2 size={22} style={{ width: "25px" }} />}
          placeholder={isWorkspace ? getTranslation("workspaceTitle") : getTranslation("projectTitle") + "*"}
          value={projectTitle}
          onChange={(e) => setProjectTitle(e.target.value)}
          type={"text"}
        />

        <div className="add-project-modal-content">
          <IoDocumentTextOutline
            size={20}
            style={{
              width: "25px",
              alignSelf: "flex-start",
              marginTop: "10px",
            }}
          />
          <textarea
            className="add-project-modal-textarea"
            placeholder={getTranslation("description")}
            value={projectDescription}
            rows={6}
            onChange={(e) => setProjectDescription(e.target.value)}
          ></textarea>
        </div>

        <div className="add-project-modal-actions">
          <button
            className="add-project-modal-button create"
            onClick={handleCreate}
          >
            {isEdit ? getTranslation("save") : getTranslation("create")}
          </button>
        </div>
      </div>
    </div>
  );
}
